import { FormRestructureEvent } from "../core/";
import { validationServiceInstance } from "./service";

let added = false;

/**
 * @param {HTMLFormElement} form 
 */
export function addIntegerValidation(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;
		
			let inputs = /** @type {HTMLInputElement[]} */ ([...entry.field.querySelectorAll(`:scope input[type="number"]`)]);
			inputs = inputs.filter(e => e.step && !e.step.includes("."));

			for (const input of inputs) {
				if (input.dataset.inputInteger !== "true") continue;

				input.addEventListener("beforeinput", ev => {
					if (ev.data && ev.data.includes(".")) {
							ev.preventDefault();
					}
				});
			}
		}
	});

	if (!added) {
		added = true;
		validationServiceInstance.addProvider("integer", integerValidationProvider);
	}
}

export const defaultIntegerErrorMessage = "Must be an integer value (without a decimal point).";

/**
 * @type {import("aspnet-client-validation").ValidationProvider}
 */
export const integerValidationProvider = (value, element, params) => {
	if (!(element instanceof HTMLInputElement)) return true;
	if (element.type !== "number") return true;
	if (element.step && (element.step === "any" || element.step.includes("."))) return true;
	if (!element.dataset.valInteger) return true;
	
	return !value.includes(".");
}
